// [日本維運] 協助商店 Panasonic (ID: 15052) 微調CMS商品區塊價格顯示樣式
// https://17media.atlassian.net/browse/HU-9862

import { toGroupingNumber } from '@/utils/transformer/number';

export const formatPriceForPanasonic = (formattedNumber: string): string =>
  `${formattedNumber}円（税込）`;

export const getPriceRangeForPanasonic = (validPrices: number[]): string => {
  // Panasonic 規範：零元價格不得顯示，需先過濾後再計算區間
  const nonZeroPrices = validPrices.filter((price) => price !== 0);
  if (nonZeroPrices.length === 0) { return ''; }
  const min = Math.min(...nonZeroPrices);
  const max = Math.max(...nonZeroPrices);
  if (min !== max) {
    return `${toGroupingNumber(min) ?? ''}～${formatPriceForPanasonic(toGroupingNumber(max) ?? '')}`;
  }
  return formatPriceForPanasonic(toGroupingNumber(min) ?? '');
};
